export const csCzech = {
  "Pensil Keyword": "Czech",
  "Home": "Domov",
  "Explore Groups": "Prozkoumat Skupiny",
  "Events": "Události",
  "Groups": "Skupiny",
  "Links": "Odkazy",
  "Direct Message": "Přímá zpráva",
  "Powered by": "Provozováno na",
  "No groups here, please use + to create a new one, or join one see them here.": "Nejsou zde žádné skupiny, použijte prosím + k vytvoření nové nebo se do nějaké přidejte, podívejte se zde.",
  "Please join a group to see them here": "Chcete-li je zde vidět, připojte se ke skupině",
  "Section can only be reordered within the group!": "Sekci lze doobjednat pouze v rámci skupiny!",
  "Group Page": "Skupinová stránka",
  "Invite Members": "Pozvat členy",
  "Join": "Připojte se",
  "Joined": "Připojeno",
  "Create new section": "Vytvořit novou sekci",
  "Group Setting drop down": "Rozbalovací nabídka Nastavení skupiny",
  "Share": "Podíl",
  "Edit group": "Upravit skupinu",
  "Delete group": "Smazat skupinu",
  "Leave": "Dovolená",
  "Are you sure you want to delete the group?": "Opravdu chcete smazat skupinu?",
  "Cancel": "Zrušit",
  "Yes, Go Ahead": "Ano, pokračujte",
  "Share via link": "Sdílejte prostřednictvím odkazu",
  "Copy": "Kopie",
  "Copied": "Zkopírováno",
  "Share on social media": "Sdílejte na sociálních sítích",
  "Add Section": "Přidat sekci",
  "Section Header": "Záhlaví sekce",
  "Live": "Žít",
  "Create Post": "Vytvořit příspěvek",
  "Notificaiton Bell": "Oznamovací zvonek",
  "All posts": "Všechny příspěvky",
  "Admin posts only": "Pouze příspěvky administrátora",
  "None": "Žádný",
  "Section Setting drop down": "Rozbalovací nabídka Nastavení sekce",
  "Edit Section": "Upravit sekci",
  "Embed Section": "Sekce vložení",
  "Delete Section": "Smazat sekci",
  "Are you sure you want to delete the section?": "Opravdu chcete sekci smazat?",
  "Section deleted!": "Sekce smazána!",
  "Create Group Pop up / Update": "Vytvořit vyskakovací okno skupiny / aktualizovat",
  "Create group": "Vytvořit skupinu",
  "Basic Detail": "Základní detail",
  "Settings": "Nastavení",
  "Size 16:9 or 1600 by 900": "Velikost 16:9 nebo 1600 x 900",
  "Group name": "Název skupiny",
  "Enter group name": "Zadejte název skupiny",
  "Suggestions: Spaces, Channels, Groups, Blog, Knowledgebase, etc": "Návrhy: Prostory, Kanály, Skupiny, Blog, Databáze znalostí atd",
  "Group Description": "Popis skupiny",
  "Enter description here": "Zde zadejte popis",
  "Group Type": "Typ skupiny",
  "Open": "OTEVŘENO",
  "Visible to all & anyone can join": "Viditelné pro všechny a kdokoli se může připojit",
  "Closed": "ZAVŘENO",
  "User will have to request to join the group": "Uživatel bude muset požádat o připojení ke skupině",
  "Paid": "Zaplaceno",
  "Group Price": "Skupinová cena",
  "Currency (Default: INR)": "Měna (výchozí: INR)",
  "User will have to pay to join the group": "Uživatel bude muset za připojení ke skupině zaplatit",
  "Make this a private group": "Udělejte z toho soukromou skupinu",
  "Private group will only be visible to members who are part of it. Admin can add members manually from member list": "Soukromá skupina bude viditelná pouze členům, kteří jsou její součástí. Admin může přidat členy ručně ze seznamu členů",
  "Upload from device": "Nahrát ze zařízení",
  "Search image": "Vyhledat obrázek",
  "Valid group name required!": "Je vyžadován platný název skupiny!",
  "Update Group": "Aktualizovat skupinu",
  "SEO Settings": "Nastavení SEO",
  "Custom URL": "Vlastní adresa URL",
  "Meta Title": "Název metadat",
  "Maximum length of 255 characters allowed": "Maximální povolená délka 255 znaků",
  "Meta Description": "Popis metadat",
  "Open Graph Detail": "Otevřete Detail grafu",
  "Open Graph Title": "Otevřete název grafu",
  "Open Graph Description": "Otevřete popis grafu",
  "Open Graph Image": "Otevřete obrázek grafu",
  "Recommended dimensions: 1200px by 630px with a 1.91:1 aspect ratio.": "Doporučené rozměry: 1200 x 630 pixelů s poměrem stran 1,91:1.",
  "If no URL is used, it will automatically picked your group thumbnail.": "Pokud není použita žádná adresa URL, automaticky vybere miniaturu vaší skupiny.",
  "Create Section Pop up / Update": "Vytvořit vyskakovací okno sekce / Aktualizovat",
  "Create Section": "Vytvořit sekci",
  "Section Name": "Název sekce",
  "Suggestions: General, Introductions, Community Guidelines": "Návrhy: Obecné, Úvody, Pokyny pro komunitu",
  "Section Type": "Typ sekce",
  "Post Type": "Typ příspěvku",
  "Group Chat": "Skupinový chat",
  "Who can post in this section?": "Kdo může přispívat do této sekce?",
  "Only Admin": "Pouze Admin",
  "Any user": "Jakýkoli uživatel",
  "Sorting order for section": "Pořadí řazení pro sekci",
  "Latest first": "Nejdříve nejnovější",
  "Oldest post first": "Nejdříve nejstarší příspěvek",
  "Section Appearance": "Sekce Vzhled",
  "List View": "Zobrazení seznamu",
  "Grid View": "Zobrazení mřížky",
  "Make this closed section": "Udělejte tuto uzavřenou sekci",
  "Members will have to request access to see section content": "Členové budou muset požádat o přístup, aby viděli obsah sekce",
  "Make this a private section": "Udělejte z toho soukromou sekci",
  "Disables requests (Make sure closed section is selected as well).": "Zakáže požadavky (ujistěte se, že je vybrána také uzavřená sekce).",
  "Post Editor": "Editor příspěvků",
  "Create new post in": "Vytvořit nový příspěvek v",
  "Add Cover Picture": "Přidat titulní obrázek",
  "Heading (Optional)": "Nadpis (volitelné)",
  "Write here..": "Pište sem..",
  "Picture": "Obrázek",
  "Video": "Video",
  "Attachment": "Příloha",
  "Poll": "Hlasování",
  "Embed Code": "Vložit kód",
  "Tags": "Tagy",
  "Toggle to question": "Přepnout na otázku",
  "Poll expire time": "Čas vypršení platnosti ankety",
  "Poll question": "Anketní otázka",
  "Enter Question": "Zadejte otázku",
  "Question": "Otázka",
  "Option": "Volba",
  "Options": "Možnosti",
  "Add Option": "Přidat možnost",
  "Poll Expiry time": "Čas vypršení platnosti ankety",
  "12 Hours": "12 hodin",
  "1 Day": "1 den",
  "2 Days": "2 dny",
  "1 Week": "1 týden",
  "2 Weeks": "2 týdny",
  "Always Open": "Vždy otevřeno",
  "Write embeddable code": "Napište vložitelný kód",
  "Click here to add embed code.": "Kliknutím sem přidáte kód pro vložení.",
  "Paste your embed code here!": "Sem vložte svůj kód pro vložení!",
  "Post Settings": "Nastavení příspěvku",
  "Update Post": "Aktualizovat příspěvek",
  "Update": "Aktualizovat",
  "Start meeting / Video call / Live": "Zahájit schůzku / Videohovor / Živě",
  "Meeting Name": "Název schůzky",
  "Suggestion: Group discussion etc": "Návrh: Skupinová diskuse atd",
  "Description": "Popis",
  "Enter description here (optional)": "Zde zadejte popis (volitelné)",
  "When do you want to start the session": "Kdy chcete zahájit relaci",
  "Right now": "Právě teď",
  "Schedule for later": "Plán na později",
  "Group video call": "Skupinový videohovor",
  "Webinar": "Webinář",
  "Go Live": "Přejít na živo",
  "Info on the Post": "Info na Postu",
  "Post comment": "Přidat komentář",
  "Comment": "Komentář",
  "Comments": "Komentáře",
  "Reply": "Odpověď",
  "Replies": "Odpovědi",
  "Share via URL": "Sdílejte prostřednictvím adresy URL",
  "Reshare in other sections": "Sdílejte dál v jiných sekcích",
  "Post Card Drop Down": "Pohlednice Rozbalovací",
  "Bookmark": "Záložka",
  "Pin post": "Připnout příspěvek",
  "Edit": "Upravit",
  "Embed Post": "Vložit příspěvek",
  "Delete": "Vymazat",
  "Remove Pin": "Odebrat špendlík",
  "Remove Bookmark": "Odebrat záložku",
  "Just copy paste this code wherever you want it to be embedded": "Stačí zkopírovat a vložit tento kód kamkoli chcete, aby byl vložen",
  "Height": "Výška",
  "Preview": "Náhled",
  "Copied to clipboard": "Zkopírováno do schránky",
  "Select Widgets": "Vyberte Widgety",
  "Add widgets to": "Přidejte widgety do",
  "You can change their order by dragging & dropping the widgets over each other": "Jejich pořadí můžete změnit přetažením widgetů přes sebe",
  "Please note: Widget wont be displayed if there is no data available,": "Poznámka: Widget se nezobrazí, pokud nejsou k dispozici žádná data,",
  "Group Members": "Členové skupiny",
  "Group Leaderboard": "Žebříček skupiny",
  "Community Leaderboard": "Žebříček komunity",
  "Trending Posts": "Populární příspěvky",
  "Group Events": "Skupinové akce",
  "Add Custom": "Přidat vlastní",
  "Save Widgets": "Uložit widgety",
  "Visible to user": "Viditelné pro uživatele",
  "Visible to admin": "Viditelné pro správce",
  "Add widget to": "Přidat widget do",
  "Upload cover picture": "Nahrajte titulní obrázek",
  "1:1 aspect ration (recommended)": "Poměr stran 1:1 (doporučeno)",
  "Card Title": "Název karty",
  "Enter widget name": "Zadejte název widgetu",
  "Small Description (try to keep it under 50 words)": "Malý popis (snažte se ho udržet pod 50 slovy)",
  "Enter description": "Zadejte popis",
  "Button Title": "Název tlačítka",
  "Enter button name": "Zadejte název tlačítka",
  "Siggestion: Know more, Join, Apply, etc": "Nápis: Zjistěte více, připojte se, přihlaste se atd",
  "URL link": "URL odkaz",
  "Create custom widget": "Vytvořte si vlastní widget",
  "Custom widget created successfully": "Vlastní widget byl úspěšně vytvořen",
  "Widgets": "Widgety",
  "Members": "členové",
  "See All": "Zobrazit vše",
  "Communtiy Top Contributors": "Hlavní přispěvatelé komunity",
  "Community Members": "Členové komunity",
  "Group Top Contributors": "Hlavní přispěvatelé skupiny",
  "Upcoming Events": "Nadcházející události",
  "Home Page Banner": "Banner domovské stránky",
  "Edit Banner": "Upravit banner",
  "Home page Edit Banner Pop up": "Úvodní stránka Upravit vyskakovací banner",
  "Update Banner": "Aktualizovat banner",
  "Search": "Vyhledávání",
  "Upload Image": "Nahrát obrázek",
  "Remove": "Odstranit",
  "Banner image (please use 16:6 ratio or 1600px by 600px image for the best view)": "Obrázek banneru (pro nejlepší zobrazení použijte poměr 16:6 nebo obrázek 1600 x 600 pixelů)",
  "Banner Title": "Název banneru",
  "Enter here": "Vstupte sem",
  "Suggestion: Welcome to my community etc": "Návrh: Vítejte v mé komunitě atd",
  "Banner Description": "Popis banneru",
  "Enter banner description": "Zadejte popis banneru",
  "Save Banner Info": "Uložit informace o banneru",
  "Home Page Feed": "Zdroj domovské stránky",
  "Recent": "Nedávné",
  "Top Posts": "Nejlepší příspěvky",
  "Trending": "Trendy",
  "Home Feed Groups": "Domácí skupiny zdrojů",
  "": "#VALUE!",
  "My Profile": "Můj profil",
  "Logout": "Odhlášení",
  "Notification": "Oznámení",
  "Notifications": "Oznámení",
  "Mark all viewed": "Označit všechny prohlížené",
  "has created a post": "Uživatel vytvořil příspěvek",
  "wants to join": "se chce připojit",
  "has commented on your post": "okomentoval váš příspěvek",
  "has replied to your comment": "Uživatel odpověděl na váš komentář",
  "Search for tags": "Hledejte značky",
  "All groups": "Všechny skupiny",
  "Search result": "Výsledek hledání",
  "No post found for selected hashtag": "Pro vybraný hashtag nebyl nalezen žádný příspěvek",
  "Start a conversation": "Zahajte konverzaci",
  "Search by name": "Hledejte podle jména",
  "Upcoming": "Nadcházející",
  "UPCOMING": "NADCHÁZEJÍCÍ",
  "Past": "Minulost",
  "PAST": "MINULOST",
  "No upcoming events": "Žádné nadcházející události",
  "Create event popup": "Vytvořit vyskakovací okno události",
  "Event details": "Podrobnosti o události",
  "16:9 aspect ratio": "Poměr stran 16:9",
  "Event name": "Název události",
  "Enter event name": "Zadejte název události",
  "Host Name": "Název hostitele",
  "You will be made host if none selected": "Pokud nebude vybrán žádný, stanete se hostitelem",
  "Write here...": "Pište sem...",
  "No. of registration for the event": "Číslo registrace na akci",
  "Unlimited": "Neomezený",
  "When & where": "Kdy & kde",
  "From": "Z",
  "Start date": "Datum zahájení",
  "time": "čas",
  "To": "Na",
  "End date": "Datum ukončení",
  "Current time zone:": "Aktuální časové pásmo:",
  "Can be updated from the communtiy setting": "Lze aktualizovat z nastavení komunity",
  "Online event": "Online akce",
  "Add meeting link": "Přidat odkaz na schůzku",
  "Meeting link will be generated once event is created": "Odkaz na schůzku bude vygenerován po vytvoření události",
  "Venue": "Místo",
  "Enter address": "Zadejte adresu",
  "Create": "Vytvořit",
  "Invite": "Pozvat",
  "Share event via link": "Sdílejte událost prostřednictvím odkazu",
  "Copy__1": "Kopie",
  "Select section to post this event": "Vyberte sekci pro přidání této události",
  "Once posted, members of that group or section will recieve an notification": "Po zveřejnění obdrží členové této skupiny nebo sekce upozornění",
  "Post": "Zveřejnit",
  "RSVP": "RSVP",
  "Book Event": "Knižní akce",
  "Yes, I'll attend": "Ano, zúčastním se",
  "May be": "Může být",
  "No, I won't attend": "Ne, nezúčastním se",
  "Date & Time": "Datum a čas",
  "Host": "Hostitel",
  "Online meeting": "Online setkání",
  "Meeting link will be visible once registered for the event": "Odkaz na schůzku se zobrazí po registraci na událost",
  "User Management": "Správa uživatelů",
  "Go bac to community": "Vraťte se do komunity",
  "Manage Members": "Spravovat členy",
  "Member": "Člen",
  "Invited": "Pozvaný",
  "Search for member": "Hledat člena",
  "Add to group": "Přidat do skupiny",
  "Send Direct Message": "Odeslat přímou zprávu",
  "Change role": "Změnit roli",
  "Kick from community": "Vyhodit z komunity",
  "Super Admin": "Super správce",
  "Super admin will have full access to the communtiy settings": "Superadmin bude mít plný přístup k nastavení komunity",
  "Group Admin": "Správce skupiny",
  "Admin of the selected group can edit the group information and create, edt or delete section under selected group": "Správce vybrané skupiny může upravovat informace o skupině a vytvářet, upravovat nebo mazat sekci pod vybranou skupinou",
  "Group Moderator": "Moderátor skupiny",
  "Group moderator can create or delete post, comment, reply & messages in the selected group.": "Moderátor skupiny může vytvářet nebo mazat příspěvky, komentáře, odpovědi a zprávy ve vybrané skupině.",
  "User": "Uživatel",
  "Save": "Uložit",
  "User role updated successfully": "Uživatelská role byla úspěšně aktualizována",
  "Leaderboard": "Žebříček",
  "Click on the column header for sorting": "Pro řazení klikněte na záhlaví sloupce",
  "Rank": "Pořadí",
  "Karma Points": "Body karmy",
  "Custom Points": "Vlastní body",
  "Follow": "Následovat",
  "Upvotes": "Hlasy pro",
  "Posts": "Příspěvky",
  "Add custom points": "Přidejte vlastní body",
  "Subtract custom points": "Odečtěte vlastní body",
  "Enter no. of points": "Zadejte č. bodů",
  "Add points": "Přidejte body",
  "Invite members to": "Pozvat členy do",
  "Invite via link": "Pozvat přes odkaz",
  "Invite via email": "Pozvat e-mailem",
  "Add more": "Přidejte další",
  "Upload a CSV": "Nahrajte soubor CSV",
  "Please upload a comma-seprated CSV file, with header as name, email.": "Nahrajte prosím soubor CSV oddělený čárkami se záhlavím jako jméno, e-mail.",
  "Here is a template CSV file": "Zde je šablona souboru CSV",
  "Upload File": "Nahrát soubor",
  "Send Invite": "Odeslat pozvánku",
  "Mail Template": "Šablona pošty",
  "Send Test Mail": "Odeslat zkušební e-mail",
  "Hey": "Hej",
  "A has invite you to join the B": "A vás zve, abyste se připojili k B",
  "Switch to rich text editor": "Přepnout do editoru formátovaného textu",
  "Add Custom Message": "Přidat vlastní zprávu",
  "Enter message here": "Zde zadejte zprávu",
  "Send Bulk Mail": "Poslat hromadnou poštu",
  "Send Mail": "Odeslat poštu",
  "Send bulk mail to all community members or select group members": "Odešlete hromadnou poštu všem členům komunity nebo vybraným členům skupiny",
  "Date": "Datum",
  "Subject": "Podrobit",
  "Recipients": "Příjemci",
  "1000 bulk emails remaining for this month. Resets on <date>": "Pro tento měsíc zbývá 1000 hromadných e-mailů. Resetuje se dne <datum>",
  "Everyone": "Každý",
  "Enter mail subject": "Zadejte předmět e-mailu",
  "Write message": "Napište zprávu",
  "Cancel__1": "Zrušit",
  "Send": "Poslat",
  "__1": "#VALUE!",
  "Activity": "Aktivita",
  "Bookmarks": "Záložky",
  "Edit Profile": "Upravit profil",
  "Unsubscribe": "Odhlásit odběr",
  "Settings (Account)": "Nastavení (účet)",
  "Profile": "Profil",
  "Set Profile Picture": "Nastavit obrázek profilu",
  "Your name": "Vaše jméno",
  "User ID": "ID uživatele",
  "Short bio": "Krátký životopis",
  "Link your social account": "Propojte svůj sociální účet",
  "This will be displayed on your profile": "To se zobrazí na vašem profilu",
  "Add social handle": "Přidat sociální úchyt",
  "Verification": "Ověření",
  "Account Verification": "Ověření účtu",
  "Email": "E-mail",
  "Enter email": "Zadejte email",
  "Verified": "Ověřeno",
  "Unverified": "Neověřeno",
  "Change": "Přeměna",
  "Unlink": "Odpojit",
  "Mobile": "Mobilní",
  "enter mobile no.": "zadejte č. mobilu",
  "Request OTP": "Vyžádejte si OTP",
  "Manage your personal account notification preferences": "Spravujte předvolby oznámení o svém osobním účtu",
  "Prefrences": "Předvolby",
  "Email notification": "Upozornění e-mailem",
  "Notify me about comments on my posts": "Informujte mě o komentářích k mým příspěvkům",
  "Notify me about replies on my comments": "Informujte mě o odpovědích na mé komentáře",
  "Notify me about upvotes on my posts": "Informujte mě o kladných hlasech u mých příspěvků",
  "Notify me about reaction on my comments": "Informujte mě o reakci na mé komentáře",
  "Notify me about reaction on my reply": "Informujte mě o reakci na mou odpověď",
  "Notify me about direct message": "Informujte mě o přímé zprávě",
  "Notify me about my mentions": "Informujte mě o mých zmínkách",
  "Notification for new posts": "Upozornění na nové příspěvky",
  "Only group & section available which you are part of": "K dispozici je pouze skupina a sekce, které jste součástí",
  "Group & Section": "Skupina a sekce",
  "All activity": "Veškerá činnost",
  "Post by admin": "Příspěvek od admina",
  "No Notification": "Žádné oznámení",
  "Setting (Community)": "Nastavení (komunita)",
  "General Settings": "Obecná nastavení",
  "Upload community logo": "Nahrajte logo komunity",
  "Community name": "Název komunity",
  "Invalid field": "Neplatné pole",
  "Your community address": "Adresa vaší komunity",
  "Fav icon": "Oblíbená ikona",
  "This will be visible on the browser tab (32px by 32px)": "Toto bude viditelné na kartě prohlížeče (32 x 32 pixelů)",
  "TimeZone": "Časové pásmo",
  "Privacy Policy on login page": "Zásady ochrany osobních údajů na přihlašovací stránce",
  "Terms & Condition on login page": "Podmínky na přihlašovací stránce",
  "Enter link here": "Zde zadejte odkaz",
  "Open Group Image": "Otevřete obrázek skupiny",
  "By default ir takes up the community banner uploaded with the communtiy": "Ve výchozím nastavení zabírá banner komunity nahraný s komunitou",
  "Community Experience": "Zkušenosti komunity",
  "Onboarding": "Přihlášení",
  "Make your community private": "Udělejte svou komunitu soukromou",
  "Users will have to login or sign up to access the community": "Uživatelé se budou muset přihlásit nebo zaregistrovat pro přístup do komunity",
  "Make account verification mandatory for both email & mobile": "Zaveďte ověření účtu jako povinné pro e-mail i mobilní zařízení",
  "New user will have to verify both email & mobile no. to access the community": "Nový uživatel bude muset ověřit e-mail i číslo mobilního telefonu. pro přístup ke komunitě",
  "Admin will also have to verify their mobile no. & email or else they won't be able to access the community": "Admin bude také muset ověřit své mobilní číslo. a e-mailem, jinak nebudou mít přístup ke komunitě",
  "Gated community access": "Uzavřený komunitní přístup",
  "Admin will have to approve or reject user's requests to join the community": "Admin bude muset schválit nebo zamítnout žádosti uživatele o připojení ke komunitě",
  "Disable mobile login/register": "Zakázat mobilní přihlášení/registraci",
  "Disable email login/register": "Zakázat e-mailové přihlášení/registraci",
  "Disable google login/register": "Zakázat přihlášení/registraci Google",
  "Disable facebook login/register": "Zakázat přihlášení/registraci na facebooku",
  "Show & Hide features": "Zobrazit a skrýt funkce",
  "Hide direct chat": "Skrýt přímý chat",
  "User will not be able to send direct messages to each other": "Uživatel si nebude moci posílat přímé zprávy",
  "Hide profile picture from top right corner for mobile responsive view": "Skryjte profilový obrázek v pravém horním rohu pro zobrazení responzivní pro mobilní zařízení",
  "Useful when using community in an in app browser": "Užitečné při používání komunity v prohlížeči v aplikaci",
  "Hide profile picture from top right corner in every view": "Skrýt profilový obrázek z pravého horního rohu v každém zobrazení",
  "Disable header dropdown on profile picture": "Zakázat rozevírací seznam záhlaví na profilovém obrázku",
  "Useful for integrated community, especially using SSO": "Užitečné pro integrovanou komunitu, zejména pomocí SSO",
  "Hide the communtiy logo from the header": "Skryjte logo komunity v záhlaví",
  "Hide the communtiy title from the header": "Skryjte název komunity v záhlaví",
  "Show collpased group in the side nav bar": "Zobrazit sbalenou skupinu na bočním navigačním panelu",
  "Show full expanded post in the home feed": "Zobrazit celý rozbalený příspěvek na domovské stránce",
  "Hide the leaderboard score from the header": "Skryjte skóre výsledkové tabulky v záhlaví",
  "Show powered by Pensil": "Show powered by Pensil",
  "Hide closed groups if not joined": "Skryjte uzavřené skupiny, pokud nejste připojeni",
  "Closed groups would not be shown to the user if they are not a member of the group": "Uzavřené skupiny se uživateli nezobrazí, pokud nejsou členem skupiny",
  "Hide Community subscriber count from the users": "Skrýt před uživateli počet odběratelů komunity",
  "This will hide the community subscriber list in the community header": "Tím se skryje seznam odběratelů komunity v záhlaví komunity",
  "Disable Communtiy Switcher": "Deaktivujte přepínač Communtiy",
  "Use MD editor for create post description": "Pro vytvoření popisu příspěvku použijte editor MD",
  "Non logged in user will land on explore group page instead of post directory": "Nepřihlášený uživatel se dostane na stránku skupiny prozkoumat místo do adresáře příspěvků",
  "Advanced configurable": "Pokročilé konfigurovatelné",
  "Communtiy default country code": "Výchozí kód země komunity",
  "This will show up by default on login/signup": "To se zobrazí ve výchozím nastavení při přihlášení/registraci",
  "Onboarding/Welcome Message": "Vstupní/uvítací zpráva",
  "Welcome Message": "Uvítací zpráva",
  "Greet your members with personalized message": "Pozdravte své členy personalizovanou zprávou",
  "Welcome to": "Vítejte na",
  "Message": "Zpráva",
  "Add message": "Přidat zprávu",
  "Custom domain": "Vlastní doména",
  "Add custom domain": "Přidat vlastní doménu",
  "Create new request": "Vytvořte nový požadavek",
  "Enter your custom domain": "Zadejte svou vlastní doménu",
  "Setup details": "Podrobnosti o nastavení",
  "Add a CNAME record in your domain pointing to this community's address": "Přidejte záznam CNAME ve své doméně odkazující na adresu této komunity",
  "To configure your domain, you'll need to add a CNAME record pointing your domain to your pensil community URL": "Chcete-li nakonfigurovat svou doménu, budete muset přidat záznam CNAME, který odkazuje vaši doménu na adresu URL vaší komunity pensil",
  "Step by Step help apge": "Nápověda krok za krokem apge",
  "All request list": "Seznam všech požadavků",
  "Allow admin to assign/un-assign custom points to users": "Povolit správci přidělovat/rušit přidělování vlastních bodů uživatelům",
  "Base points for user to begin with": "Základní body pro uživatele pro začátek",
  "Base points will be updated for all the users, any changes will reflect for all the users.": "Základní body budou aktualizovány pro všechny uživatele, jakékoli změny se projeví u všech uživatelů.",
  "Allocate points for interaction": "Přidělujte body za interakci",
  "Upvoting post": "Hlasující příspěvek",
  "creating a comment": "vytvoření komentáře",
  "creating a reply": "vytvoření odpovědi",
  "Getting upvote to their post": "Získání hlasu pro jejich příspěvek",
  "Getting comment to their post": "Získávání komentáře k jejich příspěvku",
  "Getting reply to their comment": "Získání odpovědi na jejich komentář",
  "Creating a post": "Vytvoření příspěvku",
  "Visiblity": "Viditelnost",
  "Move Up": "Posunout nahoru",
  "Move Down": "Přesunout dolů",
  "Create embedded section": "Vytvořte vloženou sekci",
  "Preview area": "Oblast náhledu",
  "Theme selector": "Volič motivu",
  "Community Theme": "Téma komunity",
  "Select theme": "Vyberte téma",
  "Select brand color": "Vyberte barvu značky",
  "Customize your button color to match your brand": "Přizpůsobte si barvu tlačítka tak, aby odpovídala vaší značce",
  "Select on button text color": "Vyberte barvu textu tlačítka",
  "Suggestion: Keep inverted contrast against brand color": "Návrh: Zachovejte obrácený kontrast proti barvě značky",
  "Billing": "Fakturace",
  "Current plan": "Aktuální plán",
  "You are current on Free PLan": "Jste aktuální na Free Plan",
  "Renew on: NA": "Prodloužit dne: NA",
  "Select": "Vybrat",
  "Email us at": "Napište nám na adresu",
  "Compare plan": "Porovnejte plán",
  "API Keys": "Klíče API",
  "Create new key": "Vytvořte nový klíč",
  "Total keys": "Celkem klíčů",
  "Keep your API keys safe! You can use them to access specific feature & let cetain apps perfrom certain actions on your behalf on the platform.": "Udržujte své API klíče v bezpečí! Můžete je použít k přístupu ke konkrétní funkci a umožnit některým aplikacím provádět určité akce vaším jménem na platformě.",
  "Key name": "Název klíče",
  "Key value": "Hodnota klíče",
  "Action": "Akce",
  "Group updated!": "Skupina aktualizována!",
  "Are you sure you want to": "Jste si jistý, že chcete?",
  "Make Moderator": "Udělejte si moderátora",
  "Remove from group": "Odebrat ze skupiny",
  "Show All": "Zobrazit vše",
  "Change Role": "Změnit roli",
  "Close": "Blízko",
  "copy": "kopie",
  "LINKS": "ODKAZY",
  "Email Id": "ID e-mailu",
  "Name": "Jméno",
  "Search for an image": "Vyhledejte obrázek",
  "Crop Image": "Oříznout obrázek",
  "No photos found": "Nebyly nalezeny žádné fotografie",
  "Community": "Společenství",
  "Banner ratio - 16:9": "Poměr bannerů - 16:9",
  "Banner Ratio - 16:6": "Poměr bannerů – 16:6",
  "Share on mail": "Sdílet na mail",
  "Share on Telegram": "Sdílejte na Telegramu",
  "Share on Whatsapp": "Sdílejte na Whatsapp",
  "Share on Linkedin": "Sdílet na Linkedin",
  "Share on Facebook": "Sdílejte na Facebooku",
  "Share on Twitter": "Sdílejte na Twitteru",
  "Pin Post": "Připnout příspěvek",
  "Heading (optional)": "Nadpis (volitelné)",
  "Select section": "Vyberte sekci",
  "Gif": "Gif",
  "Create Custom Widget": "Vytvořit vlastní widget",
  "Are you sure you want to delete this widget?": "Opravdu chcete tento widget smazat?",
  "Go to event": "Přejít na událost",
  "Add Tags": "Přidat značky",
  "Create Tag": "Vytvořit značku",
  "Title (Optional)": "Název (volitelné)",
  "Search Gif": "Hledat Gif",
  "What's on your mind": "Co máš na srdci",
  "Looks like nothing available here right now.": "Zdá se, že tu momentálně není nic k dispozici.",
  "Try exploring other tabs": "Zkuste prozkoumat další karty",
  "Delete Widget": "Smazat widget",
  "Please select a section to post": "Vyberte prosím sekci, kterou chcete zveřejnit",
  "Post added successfully!": "Příspěvek byl úspěšně přidán!",
  "Failed to create post. Please check post content and retry again.": "Příspěvek se nepodařilo vytvořit. Zkontrolujte obsah příspěvku a zkuste to znovu.",
  "Are you sure you want to discard current post?": "Opravdu chcete zahodit aktuální příspěvek?",
  "By default it will take up the image uploaded with the post": "Ve výchozím nastavení zabere obrázek nahraný s příspěvkem",
  "Quiz can be only viewed and attempted from mobile device right now!": "Kvíz lze právě teď zobrazit a vyzkoušet pouze z mobilního zařízení!",
  "Community Banner": "Banner komunity",
  "Change Cover": "Vyměňte kryt",
  "Suggestions: Welcome to my community etc": "Návrhy: Vítejte v mé komunitě atd",
  "(edited)": "(upraveno)",
  "Aspect ratio (recommended)": "Poměr stran (doporučeno)",
  "Banner details updated!": "Podrobnosti banneru aktualizovány!",
  "Refresh if changes are not visible!": "Obnovte, pokud změny nejsou viditelné!",
  "Banner details could not be updated!": "Podrobnosti banneru se nepodařilo aktualizovat!",
  "Post deleted": "Příspěvek smazán",
  "Post not available. It may have been deleted.": "Příspěvek není dostupný. Možná byla smazána.",
  "Admin": "Admin",
  "Moderator": "Moderátor",
  "Bookmark added!": "Přidána záložka!",
  "Bookmark removed": "Záložka byla odstraněna",
  "Failed performing action!": "Neúspěšné provedení akce!",
  "Copy this link to share on other platforms": "Zkopírujte tento odkaz pro sdílení na jiných platformách",
  "View this event": "Zobrazit tuto událost",
  "Event": "Událost",
  "Join Meeting": "Připojte se ke schůzce",
  "The live meeting has ended": "Živé setkání skončilo",
  "read more...": "číst více...",
  "Load more comments": "Načíst další komentáře",
  "Post Reply": "Odeslat odpověď",
  "Post Comment": "Přidat komentář",
  "more": "více",
  "upvoted": "souhlasil",
  "1 Upvote": "1 hlas pro",
  "1 Comment": "1 komentář",
  "Please enter a title": "Zadejte název",
  "Please enter a url link": "Zadejte odkaz URL",
  "Please enter button title": "Zadejte název tlačítka",
  "Button label must be at least 20 characters": "Popisek tlačítka musí mít alespoň 20 znaků",
  "Please enter valid url": "Zadejte prosím platnou adresu URL",
  "Suggestions: Know more, Join, Apply...": "Návrhy: Zjistěte více, připojte se, přihlaste se...",
  "URL": "URL",
  "Community Events": "Komunitní akce",
  "Widget deleted successfully": "Widget byl úspěšně smazán",
  "Community Top Contributors": "Hlavní přispěvatelé komunity",
  "points": "body",
  "Points cannot be greater than current points": "Body nemohou být větší než aktuální body",
  "Point cannot be a negative value": "Bod nemůže být záporná hodnota",
  "Point cannot be a decimal point": "Tečka nemůže být desetinná čárka",
  "Please enter a valid number": "Zadejte prosím platné číslo",
  "Karma points updated successfully": "Body karmy byly úspěšně aktualizovány",
  "Error in updating karma points": "Chyba při aktualizaci bodů karmy",
  "Add karma points": "Přidejte body karmy",
  "Minus karma points": "Minus body karmy",
  "Total Karma points:": "Celkový počet bodů karmy:",
  "Enter no. of karma points": "Zadejte č. bodů karmy",
  "Minus Points": "Mínusové body",
  "Trending Post": "Trendy příspěvek",
  "No visible description": "Žádný viditelný popis",
  "Picture ratio: 1:1": "Poměr obrazu: 1:1",
  "home feed": "domácí krmivo",
  "Event name is invalid!": "Název události je neplatný!",
  "custom": "zvyk",
  "Custom widget updated successfully": "Vlastní widget byl úspěšně aktualizován",
  "Name invalid!": "Jméno je neplatné!",
  "Current timezone:": "Aktuální časové pásmo:",
  "can be updated from community settings": "lze aktualizovat z nastavení komunity",
  "Event created successfully": "Událost byla úspěšně vytvořena",
  "Error in creating event": "Chyba při vytváření události",
  "Attendees": "Účastníci",
  "Do you wish to notify these changes to attendees?": "Přejete si oznámit tyto změny účastníkům?",
  "users wants to attend this event": "uživatelé se chtějí této události zúčastnit",
  "Yes, Notify them": "Ano, upozornit je",
  "No, its okay": "Ne, to je v pořádku",
  "Do you wish to notify that event is cancelled?": "Přejete si oznámit, že akce je zrušena?",
  "Are you sure you want to delete the event?": "Opravdu chcete událost smazat?",
  "Delete Event": "Smazat událost",
  "New Event": "Nová událost",
  "Accept Invitation": "Přijměte pozvání",
  "Requested": "Vyžádáno",
  "Declined": "Odmítnuto",
  "Request Access": "Žádost o přístup",
  "Enroll for": "Zaregistrujte se pro",
  "Housefull": "Dům plný",
  "Just copy paste this code wherever you want it to be embedded:": "Stačí zkopírovat a vložit tento kód kamkoli ho chcete vložit:",
  "Ended": "Skončilo",
  "Error getting events": "Chyba při získávání událostí",
  "Events could not be fetched!": "Události se nepodařilo načíst!",
  "Show Attendees": "Zobrazit účastníky",
  "Subscribers": "Předplatitelé",
  "Make this a closed section": "Udělejte z toho uzavřenou sekci",
  "Update Section": "Aktualizovat sekci",
  "Valid section name required!": "Je vyžadován platný název sekce!",
  "Enter section name": "Zadejte název sekce",
  "Community Admin": "Správce komunity",
  "Embed": "Vložit",
  "Invite to": "Pozvat na",
  "Please enter a valid email address": "Zadejte prosím platnou e-mailovou adresu",
  "Invitation sent successfully": "Pozvánka byla úspěšně odeslána",
  "Error sending invitation": "Chyba při odesílání pozvánky",
  "Email is not valid!": "Email není platný!",
  "Data could not be loaded!": "Data se nepodařilo načíst!",
  "Posted in": "Publikováno v",
  "Invite Members Individually": "Pozvat členy jednotlivě",
  "Start a discussion": "Zahájit diskuzi",
  "Post something": "Zveřejněte něco",
  "Invite your audience": "Pozvěte své publikum",
  "Choose Plan": "Vyberte Plán",
  "or": "nebo",
  "Create a link": "Vytvořte odkaz",
  "Add link": "Přidat odkaz",
  "Update link": "Aktualizovat odkaz",
  "Add shortcut to your most used tools": "Přidejte zástupce k nejpoužívanějším nástrojům",
  "Your website, Instagram Channel, Facebook profile etc": "Váš web, instagramový kanál, facebookový profil atd",
  "Valid link name required!": "Je vyžadován platný název odkazu!",
  "Valid url required, and make sure you are not missing http:// or https://": "Je vyžadována platná adresa URL a ujistěte se, že nechybí http:// nebo https://",
  "Invite to__1": "Pozvat na",
  "Link Name": "Název odkazu",
  "Link URL": "URL odkazu",
  "Could not subscribe to": "Nelze se přihlásit k odběru",
  "Subscribed to": "Přihlášeno k odběru",
  "By default it will take up the community banner uploaded with the community": "Ve výchozím nastavení zabere banner komunity nahraný s komunitou",
  "Created by": "Vytvořil",
  "Online Event (Meeting link will be visible once registered for the event)": "Online událost (odkaz na schůzku se zobrazí po registraci na událost)",
  "Join Call": "Připojte se k hovoru",
  "Please login to book this event": "Pro rezervaci této akce se prosím přihlaste",
  "Commented on": "Komentováno",
  "Replied to": "Odpovězeno na",
  "Looks like it's lonely here.": "Vypadá to, že je to tu osamělé.",
  "Try exploring other sections and groups.": "Zkuste prozkoumat další sekce a skupiny.",
  "Please proceed with the payment or contact admin to gain access to this group.": "Pokračujte prosím v platbě nebo kontaktujte administrátora, abyste získali přístup do této skupiny.",
  "This is a closed group You'll need access to this group.": "Toto je uzavřená skupina. K této skupině budete potřebovat přístup.",
  "You have no bookmarks right now.": "Momentálně nemáte žádné záložky.",
  "The user hasn't posted anything yet publicly.": "Uživatel zatím nic veřejně nezveřejnil.",
  "No activity to show.": "Žádná aktivita k zobrazení.",
  "Are you sure you want to unsubscribe the community?": "Opravdu chcete zrušit odběr komunity?",
  "deals left": "nabídky zbývají",
  "Something went wrong while loading posts": "Při načítání příspěvků se něco pokazilo",
  "Could not unsubscribe from": "Z odběru se nepodařilo odhlásit",
  "Unsubscribed from": "Odhlášeno z odběru",
  "Login to view this page": "Pro zobrazení této stránky se přihlaste",
  "Login": "Přihlášení",
  "There was some error while doing the action!": "Při provádění akce došlo k nějaké chybě!",
  "Unable to delete section!": "Sekci nelze smazat!",
  "__2": "",
  "__3": "",
  "__4": "",
  "Home page": "Domovská stránka",
  "Members Directory": "Adresář členů",
  "Calendar": "Kalendář",
  "Create Group": "Vytvořit skupinu",
  "Start Live Session": "Spusťte živou relaci",
  "Home__1": "Domov",
  "Following": "Následující",
  "__5": "",
  "Post Card": "Pohlednice",
  "Like": "Jako",
  "Comment__1": "Komentář",
  "Comment__2": "Komentář",
  "Share__1": "Podíl",
  "Report": "Zpráva",
  "Follow User": "Sledovat uživatele",
  "Report User": "Nahlásit uživatele",
  "Report Post": "Nahlásit příspěvek",
  "__6": "",
  "LeaderBoard Floating pop up": "Vyskakovací plovoucí žebříček",
  "Go to leaderboard": "Přejít na výsledkovou tabulku",
  "Total karma points": "Celkový počet bodů karmy",
  "Comments__1": "Komentáře",
  "Upvotes__1": "Hlasy pro",
  "Replies__1": "Odpovědi",
  "Post__1": "Zveřejnit",
  "Custom Points__1": "Vlastní body",
  "Base Points": "Základní body",
  "__7": "",
  "Channel": "Kanál",
  "This is a private channel": "Toto je soukromý kanál",
  "You'll need access to this channel": "Budete potřebovat přístup k tomuto kanálu",
  "__8": "",
  "Profile Page": "Stránka profilu",
  "Followers": "Následovníci",
  "Activities": "Činnosti",
  "__9": "",
  "Settings Page": "Stránka nastavení",
  "Go back to community": "Vraťte se do komunity",
  "Account": "Účet",
  "Notification Centre": "Oznamovací centrum",
  "__10": "",
  "Edit Profile Page": "Upravit stránku profilu",
  "Set profile Picture": "Nastavit profilový obrázek",
  "Your name__1": "Vaše jméno",
  "Subtitle": "Titulky",
  "(Max char 60)": "(Max 60 znaků)",
  "User Id": "ID uživatele",
  "Short Bio": "Krátký životopis",
  "Link For Social Account": "Odkaz pro sociální účet",
  "This will be displayed on your profile__1": "To se zobrazí na vašem profilu",
  "Add Social handles": "Přidejte sociální úchyty",
  "__11": "",
  "Verification Page": "Ověřovací stránka",
  "Email__1": "E-mail",
  "Verified__1": "Ověřeno",
  "__12": "",
  "Manage your personal account notification preferences__1": "Spravujte předvolby oznámení o svém osobním účtu",
  "Preferences": "Předvolby",
  "Email Notification": "Upozornění e-mailem",
  "Notify me about comment on my posts": "Informujte mě o komentářích k mým příspěvkům",
  "Notify me about replies on my comment": "Informujte mě o odpovědích na můj komentář",
  "Notify me about upvote on my post": "Informujte mě o kladném hlasování u mého příspěvku",
  "Notify me about reaction to my comment": "Informujte mě o reakci na můj komentář",
  "Notify me about reaction on my reply__1": "Informujte mě o reakci na mou odpověď",
  "Notify me about direct message__1": "Informujte mě o přímé zprávě",
  "Notify me about mentions": "Informujte mě o zmínkách",
  "Notification for new posts__1": "Upozornění na nové příspěvky",
  "Only groups and channel available which you are part of. You can also control notification": "K dispozici jsou pouze skupiny a kanál, kterých jste součástí. Můžete také ovládat oznámení",
  "Group & Channels": "Skupina a kanály",
  "All Activity": "Veškerá činnost",
  "Post by admin__1": "Příspěvek od admina",
  "No Notification__1": "Žádné oznámení",
  "__13": "",
  "Direct Message__1": "Přímá zpráva",
  "Inbox": "Doručená pošta",
  "No chats found": "Nebyly nalezeny žádné chaty",
  "__14": "",
  "Create Post Popup": "Vytvořit vyskakovací okno příspěvku",
  "Create Post in": "Vytvořit příspěvek v",
  "Select Channel": "Vyberte Kanál",
  "__15": "",
  "Dark Mode": "Tmavý režim",
  "__16": "",
  "has created a post in": "vytvořil příspěvek v",
  "joined": "se připojil",
  "wants to join__1": "se chce připojit",
  "liked your post!": "olajkoval váš příspěvek!",
  "has commented on your post in": "okomentoval váš příspěvek v",
  "has replied to your comment on a post in": "Uživatel odpověděl na váš komentář k příspěvku v",
  "has mentioned you in a post in": "se o vás zmínil v příspěvku v",
  "has mentioned you in a comment": "se o vás zmínil v komentáři",
  "has mentioned you in a reply": "se o vás zmínil v odpovědi"
}